__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.14.0", () => (__webpack_require__.e(7164).then(() => (() => (__webpack_require__(67164))))));
			register("@emotion/react", "11.14.0", () => (__webpack_require__.e(3657).then(() => (() => (__webpack_require__(53657))))));
			register("@material-ui/core/styles", "4.12.4", () => (Promise.all([__webpack_require__.e(6352), __webpack_require__.e(7289)]).then(() => (() => (__webpack_require__(92976))))));
			register("@material-ui/styles", "4.11.5", () => (Promise.all([__webpack_require__.e(4570), __webpack_require__.e(8218)]).then(() => (() => (__webpack_require__(94570))))));
			register("@mui/private-theming", "5.17.1", () => (__webpack_require__.e(1645).then(() => (() => (__webpack_require__(51645))))));
			register("@mui/styled-engine", "5.18.0", () => (Promise.all([__webpack_require__.e(2952), __webpack_require__.e(3860)]).then(() => (() => (__webpack_require__(92952))))));
			register("@mui/system", "5.18.0", () => (Promise.all([__webpack_require__.e(8535), __webpack_require__.e(1568), __webpack_require__.e(6744)]).then(() => (() => (__webpack_require__(78535))))));
			register("@openshift/dynamic-plugin-sdk", "8.2.0", () => (Promise.all([__webpack_require__.e(5027), __webpack_require__.e(7139), __webpack_require__.e(6955), __webpack_require__.e(1419), __webpack_require__.e(7326), __webpack_require__.e(2212)]).then(() => (() => (__webpack_require__(87326))))));
			register("@openshift/dynamic-plugin-sdk", "9.1.0", () => (Promise.all([__webpack_require__.e(5027), __webpack_require__.e(7139), __webpack_require__.e(6955), __webpack_require__.e(1419), __webpack_require__.e(5833), __webpack_require__.e(5478)]).then(() => (() => (__webpack_require__(5833))))));
			register("@scalprum/react-core", "0.13.1", () => (Promise.all([__webpack_require__.e(1419), __webpack_require__.e(5787), __webpack_require__.e(3425), __webpack_require__.e(5937)]).then(() => (() => (__webpack_require__(65787))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(3144), __webpack_require__.e(3097)]).then(() => (() => (__webpack_require__(43144))))));
			register("react-router-dom", "6.30.4", () => (Promise.all([__webpack_require__.e(1613), __webpack_require__.e(8419), __webpack_require__.e(2613)]).then(() => (() => (__webpack_require__(73657))))));
			register("react-router", "6.30.4", () => (Promise.all([__webpack_require__.e(1613), __webpack_require__.e(8690), __webpack_require__.e(240)]).then(() => (() => (__webpack_require__(18690))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4041).then(() => (() => (__webpack_require__(14041))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};